import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="Concubine x Casual SEX CAMPUS parte 1"
      portada="https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-1.jpg"
  paginas={[
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-1.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-2.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-3.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-4.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-5.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-6.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-7.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-8.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-9.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-10.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-11.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-12.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-13.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-14.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-15.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-16.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-17.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-18.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-19.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-20.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-21.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-22.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-23.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-24.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-25.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-26.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-27.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-28.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-29.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-30.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-31.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-32.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-33.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-34.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-35.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-36.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-37.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-38.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-39.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-40.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-41.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-42.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-43.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-44.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-45.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-46.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-47.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-48.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-49.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-50.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-51.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-52.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-53.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-54.jpg",
  "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-55.jpg"
]}
      sugeridos={[]}


      info={{
    grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [" "],
etiquetas: ["Ahegao", "Big Breasts", "Blowjob", "Cheating", "Defloration", "Digital", "Freckles", "Kissing", "Multi-work Series", "Schoolboy Uniform", "Schoolgirl Uniform", "Sole Female", "Sole Male", "Stockings"],
    artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "Concubine x Casual SEX CAMPUS parte 1",
  portada: "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-1.jpg",
  reverso: "https://fullcomics18.org/img10/concubine-x-casual-sex-campus1-20.jpg",
   fecha:"2026-05-16",


  info: {
    grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [" "],
etiquetas: ["Ahegao", "Big Breasts", "Blowjob", "Cheating", "Defloration", "Digital", "Freckles", "Kissing", "Multi-work Series", "Schoolboy Uniform", "Schoolgirl Uniform", "Sole Female", "Sole Male", "Stockings"],
    artistas: "Fuetakishi",
  },
};
